import { all, takeEvery, put, fork, call, select, takeLatest } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { clearTokenFromLocalStorage, setLoginResultsToLocalStorage, isExpirationLocalStorageValueConsideredValid, getLocalStorageValue } from '../../helpers/utility';
import actions from './actions';
import appActions from '../actions';
import { loginService, logoutService, loginWithOtpService, getCurrentUserService } from './authServices';
import { DvNotification, DvIntlMessages } from "../../components/utility/dvGeneralUtilities";
import { notification } from 'antd';
import { connectToWebSocketsChannels } from '../../helpers/socket';

let refreshAuthenticationTokenInterval = undefined;

// ---------- log in/out stuff -------------
function* checkAuthorizationFromLocalStorage() {
  const redirectAfterLoginUrl = window.location.pathname.includes("/signin") ? '/Dashboard' : window.location.pathname;
  if (isExpirationLocalStorageValueConsideredValid()) {
    const currentUser = yield call(getCurrentUserService);
    if (!currentUser) {
      yield put({type:actions.LOGOUT});
      return;
    }
    const webSocketConnection = connectToWebSocketsChannels(getLocalStorageValue('token'), currentUser.id);
    yield all([
      put({type:actions.SET_REDIRECT_AFTER_LOGIN, redirectAfterLoginUrl}),
      put({type: actions.LOGIN_SUCCESS,currentUser, webSocketConnection:webSocketConnection})
    ]);
  } else {
    yield put({type:actions.SET_REDIRECT_AFTER_LOGIN, redirectAfterLoginUrl});
  }
}

function* loginRequest(action) {
  const { username, password, rememberMe } = action;

  const response = yield call(loginService, username, password, rememberMe);
  if (response.status === 1) {
    if (response.results.requiredTwoFactorAuth) {
      DvNotification({type: 'info',titleId: '2fa.required',messageId: '2fa.required.message'});
      yield put({type: actions.LOGIN_REQUIRES_OTP});
    } else {
      const { token, tokenExpiresAt } = response.results;
      setLoginResultsToLocalStorage(token, tokenExpiresAt);
      const currentUser = yield call(getCurrentUserService);
      if (currentUser.roleNames.includes('super-admin')) {
        const webSocketConnection = connectToWebSocketsChannels(token, currentUser.id);
        yield all([
          put({ type: actions.LOGIN_SUCCESS, currentUser, webSocketConnection:webSocketConnection })
        ]);
      } else {
        yield logout();
        notification.error({message: DvIntlMessages('page.signIn.failed'),description: DvIntlMessages('page.signIn.failed.loginFailedCheckEmailPassword')});
        yield put({ type: actions.LOGIN_ERROR });
      }
    } 
  } else { 
    notification.error({message: DvIntlMessages('page.signIn.failed'),description: DvIntlMessages('page.signIn.failed.loginFailedCheckEmailPassword')});
    yield put({ type: actions.LOGIN_ERROR });
  }
}

function* loginWithOtpRequest(action) {
  const { otpCode, username, password, rememberMe } = action;
  const response = yield call(loginWithOtpService, otpCode, username, password, rememberMe);

  if (response.status === 1) {
    const {token, tokenExpiresAt} = response.results;    
    setLoginResultsToLocalStorage(token, tokenExpiresAt);
    const currentUser = yield call(getCurrentUserService);
    const webSocketConnection = connectToWebSocketsChannels(getLocalStorageValue('token'), currentUser.id);
    yield put({type: actions.LOGIN_SUCCESS,currentUser, webSocketConnection});
  } else {
    yield put({type: actions.LOGIN_ERROR});
    DvNotification({
      type: 'error',
      titleId: '2fa.error',
      messageId: '2fa.error.message',
    });
  }
}

function* loginSuccess() {
  const state = yield select();
  const redirectAfterLoginUrl=state.Auth.get('redirectAfterLoginUrl');
  const location = !redirectAfterLoginUrl || redirectAfterLoginUrl==="/" ? '/Dashboard' : redirectAfterLoginUrl;
  if (window.location.pathname!==location){
    yield put(push(location));
  } 

  // TODO: start a refresh timer
}


function* loginError() {
  yield put(push('/'));
}

function* logout() {
  // eslint-disable-next-line no-unused-vars
  const response = yield call(logoutService);
  clearTokenFromLocalStorage();
  yield put({ type: appActions.RESET_APP });

  if (refreshAuthenticationTokenInterval) clearInterval(refreshAuthenticationTokenInterval);
}



export function* watchCheckAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, checkAuthorizationFromLocalStorage);
}
export function* watchLoginRequest() {
  yield takeEvery(actions.LOGIN_REQUEST, loginRequest);
}
export function* watchLoginWithOtpRequest() {
  yield takeEvery(actions.LOGIN_WITH_OTP_REQUEST, loginWithOtpRequest);
}
export function* watchLoginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, loginSuccess);
}
export function* watchLoginError() {
  yield takeEvery(actions.LOGIN_ERROR, loginError);
}
export function* watchLogout() {
  yield takeLatest(actions.LOGOUT, logout);
}




export default function* rootSaga() {
  yield all([
    fork(watchCheckAuthorization),
    fork(watchLoginRequest),
    fork(watchLoginWithOtpRequest),
    fork(watchLoginSuccess),
    fork(watchLoginError),
    fork(watchLogout),
  ]);
}